var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.82 8.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#662885;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOWFILTER"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.41,
    cy: 4.41,
    r: 4.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.03 3.12 6.72 4.3 5.03 5.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.72 3.12 2.02 4.3 3.72 5.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/not_equal.b885b757.svg";
export { ForwardRef as ReactComponent };